import { breakpoint } from './breakpoint'
import { color } from './color'
import { elevation } from './elevation'
import { typeface } from './typeface'

export const theme = {
  color,
  elevation,
  breakpoint,
  typeface
}

export type Theme = typeof theme
